import * as R from 'ramda';
import React, { useState, useEffect } from 'react';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// utilities
import { sendRequest } from '../../../utilities/http';
import endpointsMap from '../../../utilities/endpoints';
//////////////////////////////////////////////////

const usePreselectedTrailers = (props) => {
  const { telGuid, fleetOptionsForSelect = {}, requestDriverRateData = sendRequest } = props;

  const trailersOptions = R.path(['trailersOptions'], fleetOptionsForSelect);

  const [preselectedTrailers, setPreselectedTrailers] = useState(R.pathOr([], ['preselectedTrailers'], props));
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const handleGetPreselectedTrailers = async () => {
      const options = { params: { telGuid } };

      const res = await requestDriverRateData('get', endpointsMap.telPreselectedTrailers, options);

      const { data, status } = res;

      if (G.isResponseSuccess(status)) {
        setPreselectedTrailers(data);
      } else {
        G.handleException(res, 'usePreselectedTrailers exception');
      }
    };

    if (G.isNilOrEmpty(preselectedTrailers)) handleGetPreselectedTrailers();
  }, [telGuid]);

  useEffect(() => {
    const missedOptions = R.compose(
      R.map(({ guid, unitId }) => ({ value: guid, label: unitId, lnl: '', distance: '' })),
      R.filter(
        ({ guid }) => {
          const match = R.find(R.propEq(guid, GC.FIELD_VALUE), R.or(trailersOptions, []));

          return R.not(match);
        },
      ),
    )(preselectedTrailers);

    setOptions([...R.or(trailersOptions, []), ...missedOptions]);
  }, [trailersOptions, preselectedTrailers]);

  return { preselectedTrailers, trailersOptions: options };
};

const withPreselectedTrailers = (Component) => (props) => {
  const { telGuid, fleetOptionsForSelect } = props;

  if (R.not(telGuid)) return <Component {...props} />;

  const { trailersOptions, preselectedTrailers } = usePreselectedTrailers(props);

  return (
    <Component
      {...props}
      trailersOptions={trailersOptions}
      preselectedTrailers={preselectedTrailers}
      fleetOptionsForSelect={{ ...fleetOptionsForSelect, trailersOptions }}
    />
  );
};

export {
  usePreselectedTrailers,
  withPreselectedTrailers,
};
